import { BaseUrlAuth } from "./APIURL";

export const getLoginAPIURL = BaseUrlAuth + "/login";